import DownloadIcon from '@mui/icons-material/Download';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import SearchIcon from '@mui/icons-material/Search';
import TuneIcon from '@mui/icons-material/Tune';
import { DialogActions, InputAdornment, LinearProgress, Pagination, TextField, Tooltip } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import { isFirstDayOfMonth } from 'date-fns';
import moment from 'moment';
import React, { FC, memo, useEffect, useRef, useState } from 'react';
import { CSVLink } from 'react-csv';
import { useSelector } from 'react-redux';
import { usePermissionWrapper } from 'src/components/common/hooks/usePermissionWrapper';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { AppState, useAppSelector } from 'src/store';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import DocManagementService from '../documentUpload/service/DocManagementService';
import AuditTrail from './AuditTrail';
import FilterMenu, { IActionType, IFilterDate } from './FilterMenu';

export interface AuditHistoryData {
  audit_module_section: string;
  audit_project_module: string;
  audit_user_name: string;
  changed_data: string;
  created_by: string;
  created_on: string;
  data_changed_from: string | null;
  date_time_of_change: string;
  deleted_by: null;
  deleted_on: null;
  field_changed: string;
  file_master_id: string;
  id: string;
  is_active: boolean;
  linked_table_id: string;
  reason_data_changed: string;
  tmf_document_id: string;
  updated_by: string | null;
  updated_on: string;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}));

const headersForCSV = [
  { label: 'Date of Creation', key: 'created_on' },
  { label: 'Document Name', key: 'document_name' },
  { label: 'User Name', key: 'created_by' },
  { label: 'Field Name', key: 'field_changed' },
  { label: 'Field Data', key: 'changed_data' },
  { label: 'Previous Data (if any)', key: 'data_changed_from' },
  { label: 'Reason for Change', key: 'reason_for_change' },
  { label: 'Action Type', key: 'reason_data_changed' }
];

const AuditHistory: FC<any> = ({ openAuditTrail, setOpenAuditTrail, setAnchorEl }: any) => {
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const [auditHistoryDetails, setAuditHistoryDetails] = useState<any>([]);
  const [auditHistoryDetailsCopy, setAuditHistoryDetailsCopy] = useState<any>([]);
  const maxSizeOfAuditDetails = 10000;
  const [valueFromDate, setValueFD] = React.useState('');
  const [valueTooDate, setValueTD] = React.useState('');
  const [searchValue, setSearchValue] = useState('');
  const [actionTypeAll, setActionTypeAll] = useState<boolean>(true);
  const [actionTypeDataEntry, setActionTypeDataEntry] = useState<boolean>(true);
  const [actionTypeDataChange, setActionTypeDataChange] = useState<boolean>(true);
  const [actionTypeDataAccess, setActionTypeDataAccess] = useState<boolean>(true);
  const [actionTypeComments, setActionTypeComments] = useState<boolean>(true);
  const [result, setResult] = useState([]);
  let resultData: any = [];
  let isFilter = false;
  const docService = new DocManagementService();
  const [page, setPage] = React.useState(1);
  const user: any = useAppSelector(state => state.user.user);
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);
  const [advfilter, setAdvFilter] = useState({});
  const [advDate, setAdvDate] = useState({});
  const [filterUser, setFilterUser] = useState('');
  const [filteredData, setFilteredData] = useState<any>([]);

  let TmfLevel =
    (selectedStudy === '--' || selectedStudy === '') &&
    (selectedCountry === '--' || selectedCountry == '') &&
    (selectedSite === '--' || selectedSite === '')
      ? '--'
      : (selectedCountry === '--' || selectedCountry == '') && (selectedSite === '--' || selectedSite === '')
      ? 'Study'
      : selectedSite === '--' && selectedCountry != '--'
      ? 'Country'
      : 'Site';
  if (TmfLevel === '--') {
    TmfLevel = 'Study';
  }
  const perPage = 10;
  const [noOfAuditResults, setNoOfAuditResults] = React.useState(0);
  const [paginationGrid, setpaginationGrid] = React.useState(true);
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const { checkPermission } = usePermissionWrapper();
  const downloadDateFormat = userPreferedDateFormat.includes('/')
    ? userPreferedDateFormat.replaceAll('/', '_')
    : userPreferedDateFormat.replaceAll('-', '_');
  const [openFilterSearch, setOpenFilterSearch] = React.useState(false);
  const [isProcessing, setProcessing] = useState(false);
  const [filter, setFilter] = React.useState('Newest');
  const componentRef = useRef<any>(null);

  const handleClickOpenFilterSearch = () => {
    setOpenFilterSearch(true);
  };

  const setPaginationWithGroupBy = (allAuditHistory: any[], pageNumber: number) => {
    if (searchValue && pageNumber > 1) {
      if (filteredData) {
        const begin = (pageNumber - 1) * perPage;
        const paginatedResponse = filteredData[0].slice(begin, begin + perPage);
        setAuditHistoryDetails(groupBy(paginatedResponse, 'date_change'));
      } else {
        setAuditHistoryDetails(filteredData);
      }
    } else {
      if (allAuditHistory) {
        const begin = (pageNumber - 1) * perPage;
        const paginatedResponse = allAuditHistory[0].slice(begin, begin + perPage);
        setAuditHistoryDetails(groupBy(paginatedResponse, 'date_change'));
      } else {
        setAuditHistoryDetails(allAuditHistory);
      }
    }
  };

  const handlePagination = (event: React.ChangeEvent<unknown>, value: number) => {
    if (value !== page) {
      componentRef.current.scrollTo(0, 0);
      if (searchValue) setPaginationWithGroupBy(filteredData, value);
      else setPaginationWithGroupBy(auditHistoryDetailsCopy, value);
    }
    setPage(value);
  };

  const getAuditHistory = async (size: any, order: any, action?: any) => {
    setAdvFilter(action);
    const filter = [
      action ? (action.actionTypeDataAccess.value ? action.actionTypeDataAccess.text : '') : 'Document Access',
      action ? (action.actionTypeComments.value ? action.actionTypeComments.text : '') : 'Comments',
      action ? (action.actionTypeDataChange.value ? action.actionTypeDataChange.text : '') : 'Data Change',
      action ? (action.actionTypeDataEntry.value ? action.actionTypeDataEntry.text : '') : 'Data Entry',
      action ? (action.actionTypeWorkflow.value ? action.actionTypeWorkflow.text : '') : 'Workflow',
      action ? (action.actionTypeDataEntry.value ? action.actionTypeDataEntry.text : '') : ''
    ];
    const filterValue = filter.filter(function (item: any) {
      return item != '';
    });
    const data = [
      {
        name: 'reason_data_changed',
        value: isFilter ? filterValue : filter,
        operation: 'in'
      }
    ];
    const params = {
      module_section_related: 'DocumentDetails',
      parent_entity_related: 'Document Audit'
    };
    const response: any = await docService.getAuditDetails(
      documentDetail.data[0].fileId,
      size,
      order,
      data,
      selectedStudy,
      selectedCountry,
      selectedSite,
      TmfLevel,
      params
    );
    setProcessing(false);
    if (response.data) {
      const test = response.data.map((el: any) => {
        el.date_change = moment(new Date(el.date_time_of_change)).format('YYYY-MM-DD'); // for doing groupBy just on the date
        return el;
      });
      setResult(test);
      resultData = [test]; // declared [[this variable because setResult is not setting the state immediately when handlefilter function is called
      resultData?.length == 0 ? setpaginationGrid(false) : setpaginationGrid(true);
      setNoOfAuditResults(resultData[0]?.length);
      setAuditHistoryDetails(resultData);
      setAuditHistoryDetailsCopy(resultData);
      setPaginationWithGroupBy(resultData, 1);
      setPage(1);
    } else {
      setAuditHistoryDetails([]);
      setAuditHistoryDetailsCopy([]);
    }
    return resultData;
  };

  const handlefilter = async (action: IActionType, date: IFilterDate, user: string) => {
    setAdvDate(date);
    setFilterUser(user);
    setAdvFilter(action);
    // if (date.valueFromDate.toLocaleString() === 'Invalid Date' || date.valueTooDate.toLocaleString() === 'Invalid Date')
    //   store.dispatch(setSnackbarMessage('Invalid date format.', 'error'));
    isFilter = true;
    let result: any = [];
    const v: any = await getAuditHistory(maxSizeOfAuditDetails, filter === 'Newest' ? 'desc' : 'asc', action);

    if (v) {
      if (date.valueFromDate && date.valueTooDate && user) {
        const resultProductData = v[0].filter(function (a: any) {
          const startDate = new Date(date.valueFromDate);
          const endDate = new Date(date.valueTooDate);
          const dateChange = new Date(new Date(a.date_change).setHours(0, 0, 0, 0));
          return dateChange >= startDate && dateChange <= endDate && a.created_by === user;
        });
        //const filterData = groupBy(resultProductData, 'date_change');
        resultProductData.length === 0 ? setOpenFilterSearch(false) : setOpenFilterSearch(true);
        resultProductData.length === 0 ? setpaginationGrid(false) : setpaginationGrid(true);
        const setData = resultProductData.length ? resultProductData.length : resultProductData.length;
        setNoOfAuditResults(setData);
        setAuditHistoryDetails([resultProductData]);
        setAuditHistoryDetailsCopy([resultProductData]);
        result = [resultProductData];
        setPaginationWithGroupBy([resultProductData], 1);
        setPage(1);
        setOpenFilterSearch(false);
      } else if (date.valueFromDate && date.valueTooDate) {
        const resultProductData = v[0].filter(function (a: any) {
          const startDate = new Date(date.valueFromDate);
          const endDate = new Date(date.valueTooDate);
          const dateChange = new Date(new Date(a.date_change).setHours(0, 0, 0, 0));
          return dateChange >= startDate && dateChange <= endDate;
        });
        //const filterData = groupBy(resultProductData, 'date_change');
        resultProductData.length === 0 ? setOpenFilterSearch(false) : setOpenFilterSearch(true);
        resultProductData.length === 0 ? setpaginationGrid(false) : setpaginationGrid(true);
        const setData = resultProductData.length ? resultProductData.length : resultProductData.length;
        setNoOfAuditResults(setData);
        setAuditHistoryDetails([resultProductData]);
        setAuditHistoryDetailsCopy([resultProductData]);
        result = [resultProductData];
        setPaginationWithGroupBy([resultProductData], 1);
        setPage(1);
        setOpenFilterSearch(false);
      } else if (user) {
        const resultProductData = v[0].filter(function (a: any) {
          return a.created_by === user;
        });
        //const filterData = groupBy(resultProductData, 'created_by');
        resultProductData.length === 0 ? setOpenFilterSearch(false) : setOpenFilterSearch(true);
        resultProductData.length === 0 ? setpaginationGrid(false) : setpaginationGrid(true);
        const setData = resultProductData.length ? resultProductData.length : resultProductData.length;
        setNoOfAuditResults(setData);
        setAuditHistoryDetails([resultProductData]);
        setAuditHistoryDetailsCopy([resultProductData]);
        result = [resultProductData];
        setPaginationWithGroupBy([resultProductData], 1);
        setPage(1);
        setOpenFilterSearch(false);
      }
    }
    if (searchValue) {
      await filterAuditList(searchValue, result);
    }
    setOpenFilterSearch(false);
  };

  // To groupBy response as per date
  const groupBy = (collection: any, property: string) => {
    let i = 0,
      val,
      index;
    const values = [];
    const result = [];
    for (i; i < collection.length; i++) {
      val = collection[i][property];
      index = values.indexOf(val);
      if (index > -1) result[index].push(collection[i]);
      else {
        values.push(val);
        result.push([collection[i]]);
      }
    }
    return result;
  };

  // function for filtering
  const handleSearch = (event: any) => {
    setSearchValue(event.target.value);
    filterAuditList(event.target.value);
    setFilteredAuditList(event.target.value);
  };

  const setFilteredAuditList = (searchValue: string) => {
    if (searchValue != '') {
      filterAuditList(searchValue);
    } else {
      setNoOfAuditResults(auditHistoryDetailsCopy[0].length);
      setPaginationWithGroupBy(auditHistoryDetailsCopy, 1);
      setPage(1);
    }
  };

  const filterAuditList = (value: any, audit?: any) => {
    const arrayOfFiltered = [];
    for (let i = 0; i < (audit ? audit?.length : auditHistoryDetailsCopy.length); i++) {
      const elementInArray: AuditHistoryData[] = audit ? audit[i] : auditHistoryDetailsCopy[i];
      let filtered = elementInArray?.filter(data => {
        const filterValue = value?.toLowerCase();
        return (
          data.reason_data_changed?.toLowerCase().indexOf(filterValue) > -1 ||
          data.field_changed?.toLowerCase().indexOf(filterValue) > -1 ||
          data.changed_data?.toLowerCase().indexOf(filterValue) > -1 ||
          data.created_by?.toLowerCase().indexOf(filterValue) > -1 ||
          documentDetail.data[0].isf_document_name?.toLowerCase().indexOf(filterValue) > -1
        );
      });
      if (filter === 'Newest') {
        filtered = filtered?.sort(
          (a: any, b: any) => +new Date(b.date_time_of_change) - +new Date(a.date_time_of_change)
        );
      } else {
        filtered = filtered?.sort(
          (a: any, b: any) => +new Date(a.date_time_of_change) - +new Date(b.date_time_of_change)
        );
      }
      filtered?.length == 0 ? setpaginationGrid(false) : setpaginationGrid(true);
      setNoOfAuditResults(filtered.length);
      setPage(1);
      setAuditHistoryDetails([filtered]);
      if (value === '') {
        setAuditHistoryDetailsCopy([filtered]);
      }
      setFilteredData([filtered]);

      setPaginationWithGroupBy([filtered], 1);

      arrayOfFiltered.push(filtered);
    }
    if (auditHistoryDetails.length == 0) {
      setpaginationGrid(false);
    }
  };
  const [toggleCard, setToggleCard] = useState(true);
  const [print, setPrint] = useState(true);

  useEffect(() => {
    if (print) {
      setToggleCard(false);
      setTimeout(() => {
        setToggleCard(true);
      }, 300);
    }
  }, [page, openFilterSearch, filter, auditHistoryDetails, advfilter]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (searchValue !== '') {
      setFilteredAuditList(searchValue);
    } else {
      if (JSON.stringify(advfilter) !== '{}' || JSON.stringify(advDate) !== '{}' || filterUser !== '') {
        filterAuditList('');
      } else {
        getAuditHistory(maxSizeOfAuditDetails, filter == 'Newest' ? 'desc' : 'asc');
      }
    }
  }, [filter]);

  const handleClose = () => {
    setOpenAuditTrail(false);
    setAnchorEl(null);
  };

  const handleChangeFilter = (e: any) => {
    setFilter(e.target.value);
  };

  const preparedCSVData = (allAudit: any[]) => {
    const csvData: any = [];
    allAudit.map(item => {
      item.map((item: any) => {
        if (item.changed_data !== 'None') {
          csvData.push({
            created_on: moment(new Date(item.created_on))
              .format(`${userPreferedDateFormat.toUpperCase()}, hh:mm:ss A`)
              .toString(),
            document_name: documentDetail.data[0].tmf_document_name,
            created_by: item.created_by,
            field_changed: item.field_changed,
            changed_data: item.changed_data,
            data_changed_from: item.data_changed_from,
            reason_for_change: ' ',
            reason_data_changed: item.reason_data_changed
          });
        }
      });
    });
    return csvData;
  };

  const handlePrint = () => {
    setPrint(false);
    setpaginationGrid(false);
    setAuditHistoryDetails(auditHistoryDetailsCopy);
    setTimeout(() => {
      window.print();
    }, 300);
    setTimeout(() => {
      setpaginationGrid(true);
      setPaginationWithGroupBy(auditHistoryDetailsCopy, 1);
      setPage(1);
    }, 300);
  };

  return (
    <div>
      <div className="query-modal">
        <PopupComponent aria-labelledby="customized-dialog-title" open={openAuditTrail} maxWidth="md" className="audit-history-modal">
          <DialogTitle>
            <Grid container sx={{ mb: 2 }}>
              <Grid md={10}>{`Audit Trail: ${documentDetail.data[0].tmf_document_name}`}</Grid>
              {checkPermission('download_audit_history') && (
                <Grid md={2} display="flex" justifyContent="flex-end" className="print-actions" id="no-print">
                  <Tooltip placement='top' arrow title="Print">
                    <Button onClick={e => handlePrint()} variant="text" className="grey-btn">
                      <LocalPrintshopIcon />
                    </Button>
                  </Tooltip>
                  <Tooltip placement='top' arrow title="Download as CSV">
                    <Button variant="text" className="grey-btn" sx={{ pt: 2 }}>
                      <CSVLink
                        headers={headersForCSV}
                        data={preparedCSVData(auditHistoryDetailsCopy)}
                        filename={`${documentDetail.data[0].tmf_document_name}_AuditTrail_${moment(new Date()).format(
                          `${downloadDateFormat.toUpperCase()} HH:mm:ss`
                        )}.csv`}
                      >
                        <DownloadIcon className="grey-btn" />
                      </CSVLink>
                    </Button>
                  </Tooltip>
                </Grid>
              )}
            </Grid>
            <Grid container className="search-block">
              <Grid md={9}>
                <FormControl variant="standard" sx={{ pr: 2, mt: 2 }}>
                  <TextField
                    id="input-with-icon-adornment"
                    variant="standard"
                    autoFocus
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="more"
                            id="search-filter-IconButton"
                            aria-controls={openFilterSearch ? 'search-filter' : undefined}
                            aria-expanded={openFilterSearch ? 'true' : undefined}
                            aria-haspopup="true"
                            onClick={handleClickOpenFilterSearch}
                          >
                            <TuneIcon />
                          </IconButton>

                          <FilterMenu
                            handlefilter={handlefilter}
                            openFilterSearch={openFilterSearch}
                            setOpenFilterSearch={setOpenFilterSearch}
                            valueFromDate={valueFromDate}
                            valueTooDate={valueTooDate}
                            setValueFD={setValueFD}
                            setValueTD={setValueTD}
                            setActionTypeAll={setActionTypeAll}
                            setActionTypeDataEntry={setActionTypeDataEntry}
                            setActionTypeDataChange={setActionTypeDataChange}
                            setActionTypeDataAccess={setActionTypeDataAccess}
                            setActionTypeComments={setActionTypeComments}
                            actionTypeAll={actionTypeAll}
                            actionTypeComments={actionTypeComments}
                            actionTypeDataAccess={actionTypeDataAccess}
                            actionTypeDataChange={actionTypeDataChange}
                            actionTypeDataEntry={actionTypeDataEntry}
                            setpaginationGrid={setpaginationGrid}
                          />
                        </InputAdornment>
                      )
                    }}
                    value={searchValue}
                    onChange={e => handleSearch(e)}
                  />
                </FormControl>
              </Grid>
              <Grid md={3}>
                <FormControl variant="standard" sx={{ mb: 2 }}>
                  <InputLabel id="demo-simple-select-standard-label">Sort By</InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={filter}
                    onChange={e => {
                      handleChangeFilter(e);
                    }}
                  >
                    <MenuItem value="Newest">Newest</MenuItem>
                    <MenuItem value="Oldest">Oldest</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid md={12}>{isProcessing && <LinearProgress />}</Grid>
          </DialogTitle>
          {auditHistoryDetails.length != 0 ? (
            <DialogContent className="audit-history-modal" ref={componentRef}>
            <div className="audit-card">
              {toggleCard ? (
                <div className="audit-card">
                  {auditHistoryDetails &&
                    auditHistoryDetails.map((item: React.Key | null | undefined) => (
                      <AuditTrail key={Date.now()} data={item} />
                    ))}
                </div>
              ) : null}
              </div>
            </DialogContent>
          ) : (
            <DialogContent className="audit-history-modal">
              <div className="audit-card">
                <Box sx={{ pt: 6, color: 'rgba(0,0,0,0.6)', textAlign: 'center' }}>
                    No audit trail details found for selected field/filter criteria
                </Box>
              </div>
            </DialogContent>
          )}
          <DialogActions>
            <Grid container>
              <Grid
                md={12}
                style={{
                  display: paginationGrid ? 'flex' : 'none',
                  justifyContent: 'center',
                  alignItems: 'flex-start'
                }}
              >
                <Pagination
                  count={Math.ceil(noOfAuditResults / perPage)}
                  page={page}
                  onChange={handlePagination}
                  disabled={auditHistoryDetails.length === 0}
                />
              </Grid>
              <Grid md={12} sx={{ display: 'flex', justifyContent: 'flex-end', m: 1, mt: -4 }}>
                <Button onClick={handleClose} disabled={isProcessing}>
                  Close
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </PopupComponent>
      </div>
    </div>
  );
};

export default memo(AuditHistory);
